import React from 'react';
import { Box } from '@material-ui/core';

import Header, { HeaderProps } from './Header';
import Footer from './Footer';
import SEO from './SEO';

interface PageProps {
	children: React.ReactNode;
	noPadding?: boolean;
	headerProps?: HeaderProps;
}

const Page: React.FC<PageProps> = ({ children, noPadding, headerProps }) => (
	<Box display="flex" flexDirection="column" justifyContent="space-between" height="100%">
		<SEO />
		<Header {...headerProps} />
		<Box component="main" m={noPadding ? 0 : 3} height="auto" flexGrow="1">
			{children}
		</Box>
		<Footer />
	</Box>
);

export default Page;
